import { Society, Unit, Member, Vendor, Ledger, Finance, Profile } from './types';

// Updated to match feature interfaces and enterprise standard (Numeric IDs)
export const SOCIETY_TYPES = [
  { societyTypeId: 1, societyTypeCode: 'RESIDENTIAL', societyTypeName: 'Residential Apartments' },
  { societyTypeId: 2, societyTypeCode: 'OFFICE', societyTypeName: 'Office/Work Spaces' },
  { societyTypeId: 3, societyTypeCode: 'MIXED', societyTypeName: 'Mixed Residential/Retail' },
  { societyTypeId: 4, societyTypeCode: 'VILLA', societyTypeName: 'Premium Gated Villas' },
  { societyTypeId: 5, societyTypeCode: 'CHSL', societyTypeName: 'CHSL (Co-op Society)' },
];

export const RESIDENT_TYPES = [
  { residentTypeId: 1, residentTypeCode: 'OWNER_STAY', residentTypeName: 'Registered Owner' },
  { residentTypeId: 2, residentTypeCode: 'TENANT_STAY', residentTypeName: 'Active Renter' },
  { residentTypeId: 3, residentTypeCode: 'GUEST_LONG', residentTypeName: 'Guest Long Stay' },
];

export const VERIFICATION_STATUS = [
  { verificationStatusId: 1, verificationStatusCode: 'INITIAL', verificationStatusName: 'Initial Submission' },
  { verificationStatusId: 4, verificationStatusCode: 'VERIFIED', verificationStatusName: 'Active / Cleared' },
  { verificationStatusId: 5, verificationStatusCode: 'FAILED', verificationStatusName: 'Failed criteria' },
];

export const PAYMENT_MODES = [
  { paymentModeId: 1, paymentModeName: 'Cash', typeCode: 'CASH' },
  { paymentModeId: 2, paymentModeName: 'Cheque', typeCode: 'CHEQUE' },
  { paymentModeId: 3, paymentModeName: 'NEFT/RTGS', typeCode: 'NEFT' },
  { paymentModeId: 4, paymentModeName: 'UPI', typeCode: 'UPI' },
  { paymentModeId: 5, paymentModeName: 'Credit/Debit Card', typeCode: 'CARD' },
];

export const SELLING_STATUS = [
  { unitSellingStatusId: 1, typeCode: 'OWNER_OCCUPIED', typeName: 'Owner Occupied' },
  { unitSellingStatusId: 2, typeCode: 'AVAILABLE', typeName: 'Available' },
  { unitSellingStatusId: 3, typeCode: 'SOLD', typeName: 'Sold' },
];

export const UNIT_CONFIGS = [
  { unitConfigurationTypeId: 1, typeCode: '1BHK', typeName: '1 Bedroom Hall Kitchen' },
  { unitConfigurationTypeId: 2, typeCode: '2BHK', typeName: '2 Bedroom Hall Kitchen' },
  { unitConfigurationTypeId: 3, typeCode: '3BHK', typeName: '3 Bedroom Hall Kitchen' },
  { unitConfigurationTypeId: 13, typeCode: 'SHOP', typeName: 'Ground Floor Shop' },
];

export const VENDOR_TYPES = [
  { vendorTypeId: 1, vendorTypeName: 'Freelancer/Solo Pro', typeCode: 'SOLO' },
  { vendorTypeId: 2, vendorTypeName: 'Sole Proprietor Firm', typeCode: 'PROP' },
  { vendorTypeId: 5, vendorTypeName: 'Private Limited Co.', typeCode: 'PVT' },
];

export const SERVICE_TYPES = [
  { serviceTypeId: 1, serviceTypeName: 'Plumbing & Hydraulics', typeCode: 'PLUMBING' },
  { serviceTypeId: 2, serviceTypeName: 'Electrical Maintenance', typeCode: 'ELECTRICAL' },
  { serviceTypeId: 5, serviceTypeName: 'Cleaning & Housekeeping', typeCode: 'CLEANING' },
  { serviceTypeId: 6, serviceTypeName: 'Physical Security Guarding', typeCode: 'SECURITY' },
];

export const INITIAL_SOCIETIES: Society[] = [
  {
    societyId: 1,
    societyTypeId: 1,
    societyCode: 'GVR001',
    societyName: 'Green Valley Residency',
    registrationNumber: 'REG/2023/MH/123',
    totalUnits: 120,
    societyArea: '45000',
    societyDetails: 'Luxury residential complex',
    isActive: true,
    isVisible: true
  },
];

export const INITIAL_UNITS: Unit[] = [
  {
    unitId: 1,
    unitName: 'Unit 101',
    unitNumber: '101',
    wing: 'A',
    unitArea: '1200',
    unitParkingArea: '150',
    unitDetails: 'East facing 2BHK',
    unitSellingStatusId: 1,
    unitConfigurationTypeId: 2,
    societyId: 1,
    ownerId: 1,
    isActive: true,
    isVisible: true
  },
];

export const INITIAL_MEMBERS: Member[] = [
  {
    memberId: 1,
    memberCode: 'M001',
    firstName: 'Amol',
    middleName: 'B',
    lastName: 'Kale',
    genderId: 1,
    maritalStatusId: 1,
    dateOfBirth: '1990-01-01',
    verificationStatusId: 4,
    societyId: 1,
    email: 'amolbkale@gmail.com',
    mobile: '9876543210',
    isActive: true,
    isVisible: true
  },
];

export const INITIAL_VENDORS: Vendor[] = [
  {
    vendorId: 1,
    vendorName: 'Perfect Plumbing',
    vendorLegalName: 'Perfect Plumbing Services Pvt Ltd',
    vendorCode: 'V001',
    gstNumber: '27AABCP1234A1Z5',
    taxIdentificationNumber: 'AABCP1234A',
    isActive: true,
    isVisible: true,
    email: 'contact@perfectplumbing.com',
    mobile: '9876543211',
    address: '123, Business Park, Mumbai'
  }
];

export const INITIAL_LEDGERS: Ledger[] = [
  {
    ledgerBookId: 1,
    societyId: 1,
    ledgerBookName: 'Maintenance Fund',
    ledgerBookCode: 'MF001',
    isActive: true,
    isVisible: true,
    type: 'Income',
    openingBalance: 125000
  },
];

export const INITIAL_FINANCE: Finance[] = [
  {
    transactionId: 1,
    paymentTypeId: 1,
    ledgerBookId: 1,
    vendorId: 1,
    unitId: 1,
    paymentModeId: 1,
    transactionDateTime: '2026-01-10T00:00:00',
    entryDateTime: '2026-01-10T00:00:00',
    amount: 4500,
    remarks: 'Monthly collection',
    comments: 'Paid in cash',
    entryById: 1,
    isVisible: true,
    transactionDirection: 'Income',
    description: 'Maintenance Collection Jan 2026',
    department: 'Accounts',
    date: '2026-01-10',
    societyId: 1,
    ledgerBookName: 'Maintenance Fund'
  },
];

export const INITIAL_PROFILE: Profile = {
  profileId: 1,
  userId: 1,
  titleId: 1,
  firstName: 'Amol',
  middleName: 'B',
  lastName: 'Kale',
  genderId: 1,
  dateOfBirth: '1990-01-01',
  bloodGroupId: 1,
  maritalStatusId: 1,
  profilePictureUrl: 'https://picsum.photos/seed/amol/200',
};

export const PRIVILEGED_ROLES = [
  'XSUPER_ADMIN',
  'XADMIN',
  'SOCIETY_OWNER',
  'SOCIETY_CHAIRMAN',
  'SOCIETY_SECRETARY',
  'SOCIETY_TREASURER',
] as const;
